module.exports = __webpack_public_path__ + "static/media/11140696671582004489-128.4be833b0.png";